interface Props {
  children: React.ReactNode
  className?: string
}

const TableWrapper = ({ children, className = "" }: Props) => (
  <table
    className={`w-full border-collapse table-auto text-left mt-4 ${className}`}
  >
    {children}
  </table>
)

export default TableWrapper
